module.exports = __webpack_public_path__ + "static/img/tz.776b16ec.svg";